import { isWeb } from "@microdoing/shared/utils/deviceDetectors";
import React, { useCallback } from "react";
import {
  Keyboard,
  KeyboardAvoidingView,
  Pressable,
  ScrollView,
  StyleSheet,
} from "react-native";
import { Box } from "./Box";

export interface IKeyboardAvoidWrapperProps {
  children: React.ReactNode;
}

const KeyboardAvoidWrapper = ({ children }: IKeyboardAvoidWrapperProps) => {
  const handleOnDismiss = useCallback(() => {
    Keyboard.dismiss();
  }, []);

  if (isWeb) return <Box flex={1}>{children}</Box>;

  return (
    <KeyboardAvoidingView style={styles.main}>
      <ScrollView
        keyboardShouldPersistTaps="handled"
        showsVerticalScrollIndicator={false}
        scrollEventThrottle={0}
        // onMomentumScrollEnd vs onScroll for dismiss allow to trigger only when user dismiss
        onScrollBeginDrag={handleOnDismiss}
        style={styles.scrollview}
      >
        <Pressable onPress={handleOnDismiss}>{children}</Pressable>
      </ScrollView>
    </KeyboardAvoidingView>
  );
};

const styles = StyleSheet.create({
  main: {
    flex: 1,
  },
  scrollview: {
    overflow: "visible",
  },
});

export default KeyboardAvoidWrapper;
